import React from "react";
import { Modal } from "antd";
import { Select, Space } from "antd";

const AddUserModal = ({ isadduserModalOpen, setisadduserModalOpen }) => {
  const handleOk = () => {
    setisadduserModalOpen(false);
  };
  const handleCancel = () => {
    setisadduserModalOpen(false);
  };

  return (
    <div>
      <Modal
        open={isadduserModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="addusermodal"
        centered={true}
        width="60%"
      >
        <div className="modal-content">
          <h2 className="fw-bold text-medium-black text-center">Add User</h2>
          <form>
            <div className="template-div v-center h-center flex-column mt-5">
              <div className="edit-profile-main d-flex flex-column gap-5">
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Select Admin</h5>
                    <Space wrap>
                      <Select
                        defaultValue="Admin 1"
                        style={{ width: 772 }}
                        options={[
                          { value: "Admin 1", label: "Admin 1" },
                          { value: "Admin 2", label: "Admin 2" },
                          { value: "Admin 3", label: "Admin 3" },
                        ]}
                      />
                    </Space>
                  </div>
                </div>
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Type</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>First Name</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                </div>
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Email Address</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Last Name</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                </div>
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Address</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column gap-3">
                    <h5>Contact Number</h5>
                    <input
                      type="number"
                      placeholder="Type..."
                      className="modal-input "
                    ></input>
                  </div>
                </div>
              </div>

              <div className="modal-bottom-btns h-center gap-2">
                <button className="modal-dark-btn" onClick={handleCancel}>
                  Close
                </button>
                <button className="modal-dark-btn" onClick={handleOk}>
                  Update
                </button>
                <button className="modal-trans-btn">Reset</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default AddUserModal;
